"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFlagkit = _interopRequireDefault(require("react-flagkit"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _OrderStatus = _interopRequireDefault(require("../OrderStatus"));
var _iconsReact = require("../../../../icons-react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OrderCard = function OrderCard(_ref) {
  var className = _ref.className,
    _ref$attachable = _ref.attachable,
    attachable = _ref$attachable === void 0 ? false : _ref$attachable,
    _ref$detachable = _ref.detachable,
    detachable = _ref$detachable === void 0 ? false : _ref$detachable,
    _ref$countryCode = _ref.countryCode,
    countryCode = _ref$countryCode === void 0 ? '' : _ref$countryCode,
    _ref$details = _ref.details,
    details = _ref$details === void 0 ? '' : _ref$details,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href,
    hotelName = _ref.hotelName,
    hasFlights = _ref.hasFlights,
    id = _ref.id,
    _ref$region = _ref.region,
    region = _ref$region === void 0 ? '' : _ref$region,
    segment = _ref.segment,
    status = _ref.status,
    _ref$activeTicket = _ref.activeTicket,
    activeTicket = _ref$activeTicket === void 0 ? null : _ref$activeTicket,
    tickets = _ref.tickets,
    subAgentName = _ref.subAgentName,
    _ref$onClickOrderId = _ref.onClickOrderId,
    onClickOrderId = _ref$onClickOrderId === void 0 ? function (id) {
      return null;
    } : _ref$onClickOrderId,
    _ref$onAttachTicket = _ref.onAttachTicket,
    onAttachTicket = _ref$onAttachTicket === void 0 ? function (_ref2) {
      var orderId = _ref2.orderId;
      return null;
    } : _ref$onAttachTicket;
  var handleAttachTicket = (0, _react.useCallback)(function () {
    onAttachTicket({
      orderId: id
    });
  }, [onAttachTicket]);
  return /*#__PURE__*/_react["default"].createElement(StyledOrderCard, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledTopContainer, null, /*#__PURE__*/_react["default"].createElement(StyledMainInfo, null, /*#__PURE__*/_react["default"].createElement(StyledOrderStatus, {
    onClickId: onClickOrderId,
    href: href,
    id: id,
    status: status
  }), !hasFlights && /*#__PURE__*/_react["default"].createElement(StyledCrossedPlane, null), segment && /*#__PURE__*/_react["default"].createElement(StyledSegment, {
    title: segment
  }, segment)), /*#__PURE__*/_react["default"].createElement(StyledControls, null, (attachable || detachable) && /*#__PURE__*/_react["default"].createElement(StyledAttachTicketButton, {
    functional: true,
    onClick: handleAttachTicket,
    title: "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0442\u0438\u043A\u0435\u0442"
  }, /*#__PURE__*/_react["default"].createElement(StyledAttachTicketIcon, {
    detachable: detachable
  })))), !!subAgentName && /*#__PURE__*/_react["default"].createElement(StyledSubAgentName, null, subAgentName), /*#__PURE__*/_react["default"].createElement(StyledHotelName, {
    title: hotelName
  }, hotelName), /*#__PURE__*/_react["default"].createElement(StyledBottomContainer, null, countryCode && /*#__PURE__*/_react["default"].createElement(StyledCountryFlag, {
    country: countryCode
  }), /*#__PURE__*/_react["default"].createElement(StyledMiddleBottomContainer, null, /*#__PURE__*/_react["default"].createElement(StyledRegion, {
    title: region
  }, region), /*#__PURE__*/_react["default"].createElement(StyledDetails, {
    title: details
  }, details)), countryCode && /*#__PURE__*/_react["default"].createElement(StyledCountryCode, null, countryCode)), Array.isArray(tickets) && tickets.map(function (_ref3) {
    var ticket = _ref3.ticket;
    if ((activeTicket === null || activeTicket === void 0 ? void 0 : activeTicket.id) === ticket.id) return null;
    return /*#__PURE__*/_react["default"].createElement(StyledTicketLink, {
      key: ticket.id,
      href: "/tickets/".concat(ticket.id)
    }, /*#__PURE__*/_react["default"].createElement(StyledTicketArrow, null), "[".concat(ticket.id, "] ").concat(ticket.subject));
  }));
};
var StyledOrderCard = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledOrderCard",
  componentId: "sc-1kv12gm-0"
})(["width:100%;"]);
var StyledTicketLink = _styledComponents["default"].a.withConfig({
  displayName: "OrderCard__StyledTicketLink",
  componentId: "sc-1kv12gm-1"
})(["display:inline-block;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:12px;line-height:16px;color:#007aff;z-index:10;"]);
var StyledTicketArrow = (0, _styledComponents["default"])(_iconsReact.ArrowUpRight).withConfig({
  displayName: "OrderCard__StyledTicketArrow",
  componentId: "sc-1kv12gm-2"
})(["width:9px;height:8px;display:inline-block;margin-right:4px;"]);
var StyledTopContainer = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledTopContainer",
  componentId: "sc-1kv12gm-3"
})(["align-items:center;display:flex;justify-content:space-between;"]);
var StyledMainInfo = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledMainInfo",
  componentId: "sc-1kv12gm-4"
})(["align-items:center;display:flex;flex-direction:row;overflow:hidden;white-space:nowrap;"]);
var StyledOrderStatus = (0, _styledComponents["default"])(_OrderStatus["default"]).withConfig({
  displayName: "OrderCard__StyledOrderStatus",
  componentId: "sc-1kv12gm-5"
})(["display:inline-block;min-width:125px;"]);
var StyledSegment = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledSegment",
  componentId: "sc-1kv12gm-6"
})(["color:#4d4d4d;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", " + &{margin-left:10px;}"], StyledOrderStatus);
var StyledControls = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledControls",
  componentId: "sc-1kv12gm-7"
})(["display:flex;* + &{margin-left:10px;}> * + *{margin-left:10px;}"]);
var StyledAttachTicketButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "OrderCard__StyledAttachTicketButton",
  componentId: "sc-1kv12gm-8"
})(["height:14px;"]);
var StyledAttachTicketIcon = (0, _styledComponents["default"])(_iconsReact.AttachTicket).withConfig({
  displayName: "OrderCard__StyledAttachTicketIcon",
  componentId: "sc-1kv12gm-9"
})(["height:100%;width:auto;", ";"], function (_ref4) {
  var detachable = _ref4.detachable;
  return detachable && 'transform: rotateX(180deg)';
});
var StyledHotelName = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledHotelName",
  componentId: "sc-1kv12gm-10"
})(["color:#17181a;font-size:14px;font-weight:700;line-height:18px;margin-top:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledBottomContainer = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledBottomContainer",
  componentId: "sc-1kv12gm-11"
})(["color:#919499;display:flex;flex-grow:1;flex-shrink:0;font-size:12px;justify-content:space-between;margin-top:7px;"]);
var StyledCountryFlag = (0, _styledComponents["default"])(_reactFlagkit["default"]).withConfig({
  displayName: "OrderCard__StyledCountryFlag",
  componentId: "sc-1kv12gm-12"
})(["background-color:black;flex-shrink:0;height:12px;width:16px;"]);
var StyledMiddleBottomContainer = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledMiddleBottomContainer",
  componentId: "sc-1kv12gm-13"
})(["display:flex;flex-direction:column;flex-grow:1;margin:0 7px;overflow:hidden;"]);
var StyledDetails = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledDetails",
  componentId: "sc-1kv12gm-14"
})(["color:#4d4d4d;font-size:14px;height:16px;line-height:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledSubAgentName = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledSubAgentName",
  componentId: "sc-1kv12gm-15"
})(["font-size:13px;font-weight:700;color:#4b137b;margin:3px 0 8px 0;"]);
var StyledCrossedPlane = (0, _styledComponents["default"])(_iconsReact.CrossedPlane).withConfig({
  displayName: "OrderCard__StyledCrossedPlane",
  componentId: "sc-1kv12gm-16"
})(["width:18px;height:18px;margin:0 5px;"]);
var StyledRegion = (0, _styledComponents["default"])(StyledDetails).withConfig({
  displayName: "OrderCard__StyledRegion",
  componentId: "sc-1kv12gm-17"
})([""]);
var StyledCountryCode = _styledComponents["default"].div.withConfig({
  displayName: "OrderCard__StyledCountryCode",
  componentId: "sc-1kv12gm-18"
})([""]);
var _default = exports["default"] = OrderCard;